import Config from '@config';
import { initializeRolesApi } from '@gasbi/shared/common/features/roles';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export type IdentityRole = {
  id: string;
  parentId?: string | null;
  organizationId?: string | null;
  name: string;
  description?: string | null;
};

const initialized = initializeRolesApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

const extendedRolesApi = initialized.rolesApi.injectEndpoints({
  endpoints: builder => ({
    getRoles: builder.query<IdentityRole[], { organizationId?: string } | void>(
      {
        query: params => ({
          url: '',
          method: 'GET',
          params: params ?? undefined,
        }),
        providesTags: ['Roles'],
      },
    ),
  }),
});

export const {
  rolesApi,
  useGetRolePermissionsByIdQuery,
  useGetRoleAvailablePermissionsByIdQuery,
  useAssignRoleByIdMutation,
  useSuspendRoleByIdMutation,
} = initialized;

export const { useGetRolesQuery } = extendedRolesApi;
